<template>
  <div>
    <iframe width="640" height="360" frameborder="0" src="https://mega.nz/embed/Rq4hFZgZ#tpQdy28k5ZjsKQbLJMC62YuIZpDbTlaRdh-nu1IzWWw" allowfullscreen ></iframe>
  </div>
</template>

<script>
export default {};
</script>
